import ReactDOM from 'react-dom/client'
import App from './App'

import './css/index.scss'
import './css/customBootstrap.scss'
import './css/core.scss'
import {DarkModeProvider} from './common/hooks/DarkModeContext'
import {HelmetProvider} from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
    <HelmetProvider>
        <DarkModeProvider>
            <App/>
        </DarkModeProvider>
    </HelmetProvider>
)
